import React, { Component } from 'react';
import axios from 'axios';
import { DateTimePicker } from 'react-widgets'
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';

import { Container, Row, Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';

//_Partials
import Header from "../../_partials/Header/Header";
import Sidebar from "../../_partials/Sidebar/Sidebar";

// Styles
import "react-widgets/dist/css/react-widgets.css";

moment.locale('en');
momentLocalizer();

class AddEvent extends Component {

    constructor(props){
        super(props);
        this.state = {
            formData: {
                title: "",
                venue: "",
                description: "",
                price: "",
                date: "",
                start_time: "",
                end_time: "",
                apply_url: "",
            }
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({
          formData
        });
    }
    
    handleSubmit = (e) => {
        e.preventDefault();

        var record = JSON.parse(localStorage.getItem("key"));
        var token = record.token;
        const { formData } = this.state;
    
        axios({
            method: 'post',
            url: '/marketing-event',
            headers : {
                "x-access-token" : token
            },
            data: {
                date: formData.date,
                venue: formData.venue,
                start_time: formData.start_time,
                end_time: formData.end_time,
                title: formData.title,
                price: formData.price,
                description: formData.description,
                apply_url: formData.apply_url,
            }
        })
        .then(res => {
          if (res.status === 200) {
            this.setState({
              formData: { date: "", venue: "", start_time: "", end_time: "", title: "", price: "", description: "", apply_url: "" }
            });
            document.getElementById("event_form").reset();
            window.location.href = '/admin/marketing-events';
          }
        })
    }
    
    render() {
        const { formData } = this.state;
        return (
        <div className="AdminAddEvent">
            <Header />
            <Container fluid>
                <Row>
                    <Sidebar />
                    <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
                        <h2>Add Event</h2>
                        <Form id="event_form" onSubmit={this.handleSubmit} autoComplete="on">
                            <FormGroup row>
                                <Label sm={12}>Title *</Label>
                                <Col sm={12}>
                                    <Input type="text" name="title" placeholder="Event Title" onChange={this.handleChange} />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={12}>Venue *</Label>
                                <Col sm={12}>
                                    <Input type="text" name="venue" placeholder="Event location" onChange={this.handleChange} />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={12}>Description *</Label>
                                <Col sm={12}>
                                    <Input type="textarea" name="description" rows="6" placeholder="Event description" onChange={this.handleChange} />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Col sm={4}>
                                    <Label>Price *</Label>
                                    <Input type="number" name="price" placeholder="Event price" onChange={this.handleChange} />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={12}>Date *</Label>
                                <Col sm={6}>
                                    <DateTimePicker 
                                        defaultValue={null}
                                        name="date"
                                        time={false}
                                        format="DD MMM, YYYY"
                                        onChange={(value) => {
                                          try {
                                            const date = value.toISOString();
                                            this.setState({ formData: { ...formData, date }})
                                          } catch(error) {
                                            console.error('Invalid date format');
                                          }
                                        }}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Col sm={4}>
                                    <Label>Start Time *</Label>
                                    <DateTimePicker 
                                        name="start_time"
                                        date={false}
                                        defaultValue={null}
                                        format="HH:mm"
                                        timeFormat="HH:mm"
                                        onChange={(value) => {
                                          try {
                                            const start_time = value.toISOString();
                                            this.setState({ formData: { ...formData, start_time }})
                                          } catch(error) {
                                            console.error('Invalid start time format');
                                          }
                                        }}
                                    />
                                </Col>
                                <Col sm={4}>
                                    <Label>End Time *</Label>
                                    <DateTimePicker 
                                        name="end_time"
                                        date={false}
                                        defaultValue={null}
                                        format="HH:mm"
                                        timeFormat="HH:mm"
                                        onChange={(value) => {
                                          try {
                                            const end_time = value.toISOString();
                                            this.setState({ formData: { ...formData, end_time }})
                                          } catch(error) {
                                            console.error('Invalid end time format');
                                          }
                                        }}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={12}>Apply Link</Label>
                                <Col sm={12}>
                                    <Input type="text" name="apply_url" placeholder="Event Apply URI" onChange={this.handleChange} />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Col>
                                    <Button type="submit">Submit</Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </main>
                </Row>
            </Container>
        </div>
        );
    }
}
export default AddEvent;
